<template>
  <div v-loading.fullscreen.lock="false">
    <el-row>
      <el-col :offset="20" class="ignore-button" :span="7">
        <el-button-group>
          <el-button
              type="success"
              @click="handlePrint"
              icon="el-icon-files"
          ></el-button>
          <el-tooltip
              effect="dark"
              content="Cài đặt"
              placement="top-start"
          >
            <el-button
                type="success"
                @click="settingFontSize"
                icon="el-icon-setting"
            ></el-button>
          </el-tooltip>
        </el-button-group>
      </el-col>
    </el-row>
    <el-row class="rows_list">
      <div class="row_item " v-for="(itemData, index) in this.listData" :key="index" ref="documentPrint"
           :class="{ 'half-width': view > 1, 'full-width': view <= 1 }"
      >
        <div class="pdf_container" :style="customStyle">
          <br/>
          <div class="content-wrapper" style="width: 100%; margin: auto">
            <el-row class="header_kids" v-if="itemData.avatar !== null">
              <el-col :span="4">
                <img id="logo_onecam" :src="itemData.avatar" alt=""/>
              </el-col>
              <el-col :span="14" style="text-align: center; line-height: 1.5">
                <p>
                  <b style="">{{ itemData.schoolName }}</b>
                  <br/>
                  <span>{{ itemData.schoolAddress }} </span>
                  <br/>
                  <b>{{ categoryBillPreview() }}</b>
                </p>
              </el-col>
              <el-col offset="2" :span="4">
                <div style="display: flex; align-content: center; height: 100% ;padding: 10px ">
                  <img style="max-width: 100%; max-height: 80%; object-fit: contain;" :src="itemData.imgQrBank" alt=""/>
                </div>
              </el-col>
            </el-row>
            <el-row class="header_kids" v-else>
              <el-col :offset="6" :span="12" style="text-align: center; line-height: 1.5">
                <p>
                  <b style="">{{ itemData.schoolName }}</b>
                  <br/>
                  <span>{{ itemData.schoolAddress }} </span>

                  <br/>
                  <b>{{ categoryBillPreview() }}</b>
                </p>
              </el-col>
            </el-row>
            <el-row>
              <div style="float: left">
                <div style="font-weight: bold">Họ tên: {{ itemData.fullName }}</div>
                <div style="font-weight: bold">Lớp: {{ itemData.className }}</div>
                <div>SĐT: {{ itemData.phone }}</div>
                <div
                    style="font-style: italic; margin-bottom: 3px"
                >
                  Ngày {{ moment().format("DD") }} tháng
                  {{ moment().format("MM") }} năm
                  {{ moment().format("YYYY") }}
                </div>
              </div>
              <div style="float: right">
                <div style="text-align: right">Mã: ..........</div>
                <div style="text-align: right">Quyển số: ..........</div>
                <div style="text-align: right">Số: ..........</div>
                <div style="margin-bottom: 3px; text-align: right">
                  Đơn vị: VNĐ
                </div>
              </div>
            </el-row>
            <el-row>
              <table>
                <tr style="background-color: #d1d5db; text-align: center">
                  <th style="width: 5%">STT</th>
                  <th style="width: 40%">Tên khoản thu</th>
                  <th style="width: 5%">SL</th>
                  <th style="width: 15%">Đơn giá</th>
                  <th style="width: 15%">Giảm giá</th>
                  <th style="width: 20%">Thành tiền</th>
                </tr>
                <tr v-for="(data, index) in itemData.dataList.slice(0,-1)" :key="index">
                  <td v-if="!isSpecialRow(data.name)" colspan="1">
                    {{ index + 1 }}
                  </td>
                  <td
                      :colspan="isSpecialRow(data.name) ? 4 : 1"
                      :style="{ textAlign: isSpecialRow(data.name) ? 'right' : 'left', backgroundColor: data.name === 'Tổng cộng'?'#d1d5db':'white' }"
                  >
                    {{ data.name }}
                  </td>
                  <td v-if="!isSpecialRow(data.name)" colspan="1">
                    {{ data.number }}
                  </td>
                  <td v-if="!isSpecialRow(data.name)" colspan="1">
                    {{ data.price | formatCurrency }}
                  </td>
                  <td v-if="!isSpecialRow(data.name)" colspan="1">
                    {{ data.discountPrice | formatCurrency }}
                  </td>
                  <td
                      :colspan="isSpecialRow(data.name) ? 2 : 1"
                      :style="{ textAlign:  'right',backgroundColor: data.name === 'Tổng cộng'?'#d1d5db':'white' }"
                  >
                    {{ data.money | formatCurrency }}
                  </td>
                </tr>
                <tr>
                  <td :colspan="6">
                    {{
                      itemData.dataList && itemData.dataList.length > 0 ? itemData.dataList[itemData.dataList.length - 1].name : ''
                    }}
                  </td>
                </tr>
              </table>
            </el-row>
            <div
                style="
              margin-top: 4px;
              font-style: italic;
              margin-bottom: 3px;
              color: red;
            "
                class="size-note-pdf"
            >
              *{{ itemData.bankInfo }}
            </div>
            <el-row style="margin-top: 5px">
              <el-col class="print__left">
                <span><b>STK:</b> {{ itemData.accountNumberBank }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span><b>Chủ TK:</b> {{ itemData.fullNameBank }}</span>
              </el-col>
            </el-row>
            <el-row>
              <span><b>Ngân hàng:</b> {{ itemData.bankNameBank }}</span>
            </el-row>
            <el-row class="footer_field">
              <el-col :span="12"><b>Người nộp tiền</b></el-col>
              <el-col :span="12"><b>Người lập phiếu</b></el-col>
              <el-col :offset="12" :span="12" style="margin-top: 70px"><b>{{ itemData.userCreate }}</b></el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-row>
    <div>
      <el-dialog
          title="Thiết lập cỡ chữ"
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          width="300px"
      >
        <el-row>
          <el-col :span="8" style="margin-top: 8px">
            <span>Chọn cỡ chữ</span>
          </el-col>
          <el-col :span="4">
            <el-select v-model="customFontSize" placeholder="Chọn cỡ chữ" style="width: 70px" size="smail">
              <el-option
                  v-for="item in listFontSize"
                  :key="item"
                  :label="item"
                  :value="item">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="dialogVisible = false">Đóng</el-button>
         </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import SchoolConfigService from "@/services/SchoolService/SchoolConfigService";

export default {
  data() {
    return {
      listData: [],
      specialNames: [
        'Tổng cộng',
        'Số dư trong ví',
        'Số tiền đã trả',
        'Số tiền còn thiếu'
      ],
      showOrderPrintDialog: false,
      textTable: this.$tableEmpty,
      configData: {
        statusPrint: undefined,
        statusShowDateTime: undefined,
      },
      isLoading: true,
      currentTime: '',
      day: '',
      month: '',
      year: '',
      customFontSize: 13,
      dialogVisible: false,
      listFontSize: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 29, 29, 30],
    };
  },
  created() {
    // Lấy ngày hiện tại
    let now = new Date();
    // Lấy giờ-phút hiện tại
    let hours = now.getHours();
    let minutes = now.getMinutes();
    this.currentTime = `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;

// Lấy ngày-tháng-năm hiện tại
    let dayNow = now.getDate();
    this.day = `${dayNow < 10 ? '0' + dayNow : dayNow}`
    let monthNow = now.getMonth() + 1; // Tháng bắt đầu từ 0
    this.month = `${monthNow < 3 ? '0' + monthNow : monthNow}`
    this.year = now.getFullYear();
    SchoolConfigService.getConfigPrintOrder().then((res) => {
      if (res && res.data) {
        this.configData.statusPrint = res.data.statusPrint;
        this.configData.statusShowDateTime = res.data.statusShowDateTime;
      }
    })
    // cái này xử lí nếu bấm nút f5
    // if (this.billTableForOneKidPreview.length === 0 && Object.keys(this.dataSearch).length === 0) {
    //   this.$router.push('/finace/fees/orderfinance/v2')
    // }
  },
  async mounted() {
    await this.convertMoneyToString();
    this.parseData();
    this.isLoading = false;
  },
  beforeDestroy() {
    // Không cần gắn class body để tránh ảnh hưởng scroll của trang.
  },
  computed: {
    ...mapState("tuitionFeesStore", [
      "dataBill",
      'view',
      'loadingBillPreview',
      'dateSearch',
      'category'
    ]),
    customStyle() {
      return {
        '--custom-font-size': this.customFontSize + 'px'
      };
    }

  },
  // xoá dữ liệu khi back lại, f5 trang
  beforeRouteLeave(to, from, next) {
    this.$store.commit("finance2Module/renew_bill_preview");
    next(); // Xử lí tiếp tục điều hướng
  },
  methods: {
    isSpecialRow(name) {
      return this.specialNames.includes(name);
    },
    categoryBillPreview() {
      const month = new Date(this.dateSearch).getMonth() + 1 || '';
      const year = new Date(this.dateSearch).getFullYear() || '';
      if (this.category === 'both') {
        return `PHIẾU THU HỌC PHÍ THÁNG ${month}/${year}`;
      } else if (this.category === 'in') {
        return `PHIẾU THU HỌC PHÍ THÁNG ${month}/${year}`;
      } else
        return `PHIẾU CHI HỌC PHÍ THÁNG ${month}/${year}`;
    }
    ,
    settingFontSize() {
      this.dialogVisible = true
    },
    parseData() {
      if (this.view === 2) {
        this.listData = this.dataBill.flatMap(x => [x, x]);
      } else this.listData = this.dataBill;
    },
    tableHeaderColor() {
      return "background-color: #b3b3b3;color: #fff;font-weight: bold;";
    },
    tableRowStyle({row}) {
      if (
          row.name === "Tổng cộng" ||
          row.name === "Số dư trong ví" ||
          row.name === "Số tiền đã trả" ||
          row.name === "Số tiền còn thiếu" ||
          row.identify === "moneyString"
      ) {
        if (row.name === "Tổng cộng") {
          return "font-weight: bold; background: #b3b3b3";
        } else if (row.identify === "moneyString") {
          return "font-style: italic";
        } else {
          return "font-weight: bold";
        }
      }
    },
    handlePrint() {
      const isLandscape = this.view > 1;
      const printClass = isLandscape ? 'print-pdf-landscape' : 'print-pdf-portrait';

      // Gắn class lên html để non-scoped CSS nhận diện orientation
      document.documentElement.classList.add(printClass);
      document.body.classList.add(printClass);

      // Thêm @page size động
      const pageStyle = document.createElement('style');
      pageStyle.id = 'print-pdf-page-style';
      pageStyle.innerHTML = `@page { size: A4 ${isLandscape ? 'landscape' : 'portrait'}; margin: 0.3in; }`;
      document.head.appendChild(pageStyle);

      const cleanup = () => {
        document.documentElement.classList.remove(printClass);
        document.body.classList.remove(printClass);
        const el = document.getElementById('print-pdf-page-style');
        if (el) el.remove();
        window.removeEventListener('afterprint', cleanup);
      };
      window.addEventListener('afterprint', cleanup);

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          window.print();
        });
      });
    },
    async convertMoneyToString() {
      for (const data of this.dataBill) {
        const rowData = data.dataList.find((x) => x.name === "Số tiền còn thiếu");
        if (rowData && rowData.money !== undefined) {
          const {ConvertMoneyToString} = await import("@/services/ConvertMoneyToString");
          const moneyString = ConvertMoneyToString(rowData.money);
          const rowInput = {
            identify: "moneyString",
            name: moneyString,
          };
          data.dataList.push(rowInput);
        }
      }
    },
  }
};
</script>

<!-- Scoped: CHỈ dành cho màn hình preview, KHÔNG có @media print -->
<style lang="scss" scoped>
$half-width: 50%;
$full-width: 100%;
$font-family: "Times New Roman", serif;
$black: #000;

.footer_field {
  text-align: center;
}

#logo_onecam {
  margin-left: 6px;
  margin-top: 20px;
  float: left;
  object-fit: scale-down;
  width: 9vh;
  height: 8vh;
}

.header_kids {
  height: 13%;
}

.pdf_container {
  outline: 1px solid transparent;
  margin: auto;
  font-family: $font-family;
  font-size: var(--custom-font-size, 13px);
  width: $half-width;
  height: auto;
  box-shadow: 0 25px 50px -12px rgba($black, 0.25);
  transition: transform 0.3s ease-in-out;
  overflow: visible;
}

.content-wrapper {
  height: auto;
}

table {
  width: $full-width;
  border-collapse: collapse;

  th, td {
    border: 1px solid $black;
    padding: 8px;
    text-align: center;
  }
}

.print__left {
  white-space: nowrap;
  text-align: left;
}

.print__right {
  text-align: right;
}

.el-table__header {
  width: $full-width;
}

/* Màn hình: danh sách cuộn được */
.rows_list {
  display: block;
  max-height: calc(100vh - 56px);
  overflow-y: auto;
  overflow-x: hidden;
}

.row_item {
  width: $full-width;
}
</style>

<!-- Non-scoped: CHỈ dành cho in, dùng class trên html để tăng độ ưu tiên -->
<style lang="scss">
@media print {
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .ignore-button {
    display: none !important;
  }

  /* Mở khóa scroll trên toàn bộ cây DOM khi in */
  html.print-pdf-portrait,
  html.print-pdf-portrait body,
  html.print-pdf-portrait body #app,
  html.print-pdf-landscape,
  html.print-pdf-landscape body,
  html.print-pdf-landscape body #app {
    height: auto !important;
    overflow: visible !important;
    max-height: none !important;
  }

  /* Danh sách hóa đơn */
  html.print-pdf-portrait body .rows_list,
  html.print-pdf-landscape body .rows_list {
    max-height: none !important;
    overflow: visible !important;
  }

  /* ============ 1 LIÊN: A4 DỌC - mỗi phiếu thu 1 trang ============ */
  html.print-pdf-portrait body .rows_list {
    display: block !important;
  }

  html.print-pdf-portrait body .row_item {
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-after: always !important;
    break-after: page !important;
  }

  html.print-pdf-portrait body .row_item:last-child {
    page-break-after: auto !important;
    break-after: auto !important;
  }

  html.print-pdf-portrait body .pdf_container {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 8mm 10mm !important;
    box-sizing: border-box !important;
    box-shadow: none !important;
    overflow: visible !important;
    float: none !important;
    font-size: var(--custom-font-size, 13px) !important;
  }

  /* ============ 2 LIÊN: A4 NGANG - 2 phiếu thu cạnh nhau / trang ============ */
  html.print-pdf-landscape body .rows_list {
    display: flex !important;
    flex-wrap: wrap !important;
  }

  html.print-pdf-landscape body .row_item {
    display: block !important;
    width: 50% !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  /* Mỗi cặp 2 phiếu thu = 1 trang landscape */
  html.print-pdf-landscape body .row_item:nth-child(2n) {
    page-break-after: always !important;
    break-after: page !important;
  }

  html.print-pdf-landscape body .row_item:last-child {
    page-break-after: auto !important;
    break-after: auto !important;
  }

  html.print-pdf-landscape body .pdf_container {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 6mm 8mm !important;
    box-sizing: border-box !important;
    box-shadow: none !important;
    overflow: visible !important;
    float: none !important;
    font-size: var(--custom-font-size, 13px) !important;
  }

  /* Chung: ẩn thao tác, chuẩn float */
  html.print-pdf-portrait body .print__left,
  html.print-pdf-landscape body .print__left {
    float: left !important;
  }

  html.print-pdf-portrait body .print__right,
  html.print-pdf-landscape body .print__right {
    float: right !important;
  }

  html.print-pdf-portrait body .header_kids,
  html.print-pdf-landscape body .header_kids {
    margin-top: 0 !important;
    height: 13% !important;
  }
}
</style>

